// templates/hooks/useTemplatesData.js

import { useEffect, useState, useCallback } from "react";
import { Templates } from "../../../services/api/templates/list_templates";
import use123zapStore from "../../../context/123zapStore";
import { useAuth } from "../../../app/providers/AuthProvider";

export function useTemplatesData() {
  const { isAuthenticated } = useAuth();

  const templates = use123zapStore((s) => s.templates);
  const setTemplates = use123zapStore((s) => s.setTemplates);

  const alreadyFetch = use123zapStore((s) => s.alreadyFetchTemplates);
  const setAlreadyFetch = use123zapStore((s) => s.setAlreadyFetchTemplates);

  const [loading, setLoading] = useState(!alreadyFetch);
  const [isFetching, setIsFetching] = useState(false);

  const fetchTemplates = useCallback(
    async ({ silent = false } = {}) => {
      try {
        silent ? setIsFetching(true) : setLoading(true);

        const response = await Templates();

        setTemplates(response?.data || []);
        setAlreadyFetch(true);
      } catch (error) {
        console.error("Erro ao carregar templates:", error);
      } finally {
        setLoading(false);
        setIsFetching(false);
      }
    },
    [setTemplates, setAlreadyFetch]
  );

  useEffect(() => {
    if (!isAuthenticated || alreadyFetch) return;

    fetchTemplates();
  }, [isAuthenticated, alreadyFetch, fetchTemplates]);

  return {
    templates,
    loading,
    isFetching,
    refetch: () => fetchTemplates({ silent: true }),
  };
}